<app-breadcrumbs></app-breadcrumbs>
<div>
  <div id="fortigate-table-wrapper">
    <div [cfaLoading]="isLoading">
      <mat-form-field id="filter-field">
        <input matInput [(ngModel)]="filterText" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>
      <div class="toggle-container">
        <mat-slide-toggle id="offline-toggle" [(ngModel)]="onlyShowOffline" (change)="onToggle()">
          Only show offline
        </mat-slide-toggle>
        <mat-slide-toggle id="lab-toggle" [(ngModel)]="hideLabs" (change)="onToggle()">
          Hide labs
        </mat-slide-toggle>
        <mat-slide-toggle id="future-toggle" [(ngModel)]="hideFutures" (change)="onToggle()">
          Hide Futures
        </mat-slide-toggle>
        <mat-slide-toggle id="remodel-toggle" [(ngModel)]="hideRemodels" (change)="onToggle()">
          Hide Remodels
        </mat-slide-toggle>
      </div>
    </div>
    <table id="fortigate-table" #fortigateTable mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8" matSortActive="storeNumber" matSortDirection="asc">
      <ng-container matColumnDef="storeNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Store Number </th>
        <td mat-cell *matCellDef="let fortigateLocation"> {{fortigateLocation.location.number}} </td>
      </ng-container>
      <ng-container matColumnDef="locationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Name </th>
        <td mat-cell *matCellDef="let fortigateLocation"> {{fortigateLocation.location.name}} </td>
      </ng-container>
      <ng-container matColumnDef="locationStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Status </th>
        <td mat-cell *matCellDef="let fortigateLocation"> {{fortigateLocation.location.status}} </td>
      </ng-container>
      <ng-container matColumnDef="locationTimeZone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Time Zone </th>
        <td mat-cell *matCellDef="let fortigateLocation"> {{fortigateLocation.location.timezone}} </td>
      </ng-container>
      <ng-container matColumnDef="fortigates">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> FortiGates </th>
        <td mat-cell *matCellDef="let fortigateLocation">
          @for (fortigate of fortigateLocation.fortigates; track fortigate) {
            <span>
              @if (fortigate.conn_status==1) {
                <mat-icon
                  matTooltip="name: {{fortigate.hostname}}&#13;serial: {{fortigate.sn}}&#13;fortimanager ip: {{fortigate.ip}}"
                  [matTooltipClass]="'my-tooltip'"
                  class="fortigate-connected-icon">check_circle_outline
                </mat-icon>
              }
              @if (fortigate.conn_status==2) {
                <mat-icon
                  matTooltip="name: {{fortigate.hostname}}&#13;serial: {{fortigate.sn}}&#13;fortimanager ip: {{fortigate.ip}}"
                  [matTooltipClass]="'my-tooltip'"
                  class="fortigate-disconnected-icon">highlight_off
                </mat-icon>
              }
            </span>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>